"use strict";
window.theme = window.theme || {}
theme.headerNavMenu = function() {

    function headerNavMenu() {

        this.load();

    }
    headerNavMenu.prototype.load = function() {
        var _ = this; 
        document.addEventListener('DOMContentLoaded', event => {
          let keeplookingfornav = setInterval( () => {
            let navtop =  document.querySelectorAll('nav.header__links > ul > li');    
            let navcollection = document.querySelectorAll('.header__inner:not(.header__inner-sticky) .navigation-list-container.Collections > div.navigation__submenu-item');
            let stickynavcollection = document.querySelectorAll('.header__inner.header__inner-sticky .navigation-list-container.Collections > div.navigation__submenu-item');
            let collectioncontainer = document.querySelectorAll('.header__inner:not(.header__inner-sticky) .navigation-product-section > .menu-product-container');
            let stickycollectioncontainer = document.querySelectorAll('.header__inner.header__inner-sticky .navigation__submenu .navigation-submenu-container .navigation-product-section  .menu-product-container');  
            let navexperience = document.querySelectorAll('.header__inner:not(.header__inner-sticky) .navigation-list-container.Experiences > div.navigation__submenu-item');
            let stickynavexperience = document.querySelectorAll('.header__inner.header__inner-sticky .navigation-list-container.Experiences > div.navigation__submenu-item');
            let experiencecontainer = document.querySelectorAll('.header__inner:not(.header__inner-sticky) .navigation-product-section.menu-experiences > .menu-product-container');
            let stickyexperiencecontainer = document.querySelectorAll('.header__inner.header__inner-sticky .navigation-product-section.menu-experiences > .menu-product-container');
            let mobilenavtop =  document.querySelectorAll('.drawer-menu[data-drawer-menu] .drawer-menu__list > li.drawer-menu__item[data-list-item]:not(.drawer-menu__item--heading):not(.collection-all-li) > a.drawer-menu__link');
            let stickymobilenavtop =  document.querySelectorAll('.drawer-menu-sticky .drawer-menu__item[data-list-item]:not(.drawer-menu__item--heading) > a.drawer-menu__link');   
            if(navtop.length > 0 && navcollection.length > 0 && collectioncontainer.length > 0 && navexperience.length > 0 && stickycollectioncontainer.length > 0) {
              navtop.forEach(nav => {
                if(nav.hasAttribute('data-submenu-parent')) {
                  nav.addEventListener('mouseenter', event => {
                    navtop.forEach(selectednav => {
                      if(Number(selectednav.getAttribute('data-submenu-parent')) != Number(event.target.closest('li').getAttribute('data-submenu-parent')) && !event.target.closest('li').classList.contains('drag-is-enabled')) {
                          selectednav.classList.remove('col-clicked');
                      }                      
                    });
                      if(!event.target.closest('li').classList.contains('drag-is-enabled')) {
                        event.target.closest('li').classList.toggle('col-clicked');
                        collectioncontainer[0].style.setProperty('display','flex');  
                        stickycollectioncontainer[0].style.setProperty('display','flex');
                        experiencecontainer[0]?.style.setProperty('display','flex');  
                        stickyexperiencecontainer[0]?.style.setProperty('display','flex');  
                      } else {
                        event.target.closest('li').classList.remove('drag-is-enabled');
                      }                     
                 
                  })
                } else {
                  nav.addEventListener('mouseenter', _ => {
                    navtop.forEach(menu => {
                      menu.classList.remove('col-clicked')            
                    });                  
                  })
                }            
              });
              navcollection.forEach((col,index) => {
                col.addEventListener('mouseover', event => {
                  collectioncontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  experiencecontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  col.classList.add('hovered');
                  collectioncontainer[index].style.setProperty('display','flex');                
                });
              });
              stickynavcollection.forEach((col,index) => {
                col.addEventListener('mouseover', event => {
                  stickycollectioncontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  stickyexperiencecontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  col.classList.add('hovered');
                  stickycollectioncontainer[index].style.setProperty('display','flex');                
                });
              });
              navexperience.forEach((col,index) => {
                col.addEventListener('mouseover', event => {
                  collectioncontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  experiencecontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  col.classList.add('hovered');
                  experiencecontainer[index].style.setProperty('display','flex');                
                });
              });
              stickynavexperience.forEach((col,index) => {
                col.addEventListener('mouseover', event => {
                  stickycollectioncontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  stickyexperiencecontainer.forEach(con => {
                    col.classList.remove('hovered');
                    con.style.setProperty('display','none');
                  })  
                  col.classList.add('hovered');
                  stickyexperiencecontainer[index].style.setProperty('display','flex');                
                });
              });
              clearInterval(keeplookingfornav);
            }
            if(mobilenavtop.length > 0) {
              mobilenavtop.forEach(link => {
                link.addEventListener('click', event => {
                  event.preventDefault();
                  let mobiledropdown = event.target.closest('a').parentElement;
                  if(mobiledropdown)mobiledropdown.classList.toggle('drop-down');
                });              
              });
            }
            if(stickymobilenavtop.length > 0) {
              stickymobilenavtop.forEach(link => {
                link.addEventListener('click', event => {
                  if(event.target.parentElement.getAttribute('href') === '#') {
                    event.preventDefault();
                    let stickymobiledropdown = event.target.closest('a').nextElementSibling;
                    if(stickymobiledropdown)stickymobiledropdown.classList.toggle('visible');
                  }
                  if(event.target.getAttribute('href') === '#hdr_search') {
                    event.preventDefault();
                    if(event.path) {
                      if(event.path.length > 0) {
                        event.path.forEach(item => {
                          if(item.nodeName === 'HTML') {
                            item.querySelector('.header-sticky .drawer-menu.popover').classList.add('search-active')
                          }
                        })
                      }
                    }
                    event.target.nextElementSibling.classList.add('visible');
                    event.target.parentElement.classList.add('child-visible');
                  }
                });              
              });
            }

            /* Clicking on the header back button */
            document.querySelector('.drawer-menu-sticky .drawer-menu__search-parent [data-item="back"]').addEventListener('click', event => {
              const link = event.currentTarget;
              const menuBefore = link.closest('[data-list-item]').closest('ul');
              const firstFocusable = menuBefore.querySelector('.drawer-menu__link');
              const menu = link.closest('ul');
              const parentLink = menu.parentNode.querySelector('.drawer-menu__link');
              const depth = link.closest('[data-depth]');
              menu.classList.remove('visible');
              parentLink.parentNode.classList.remove('child-visible');
              depth.setAttribute('depth', (Number(depth.getAttribute('depth')) - 1));
              parentLink.setAttribute('aria-expanded', false);
              menu.setAttribute('aria-hidden', true);
              link.closest('[data-main]').style.setProperty('height', menuBefore.offsetHeight +  8 + 'px');
              if (menu.hasAttribute('data-search-menu')) {
                link.closest('[data-drawer-menu]').classList.remove('search-active');
              } 
              setTimeout(() => {
                firstFocusable.focus();
              }, 50);
              
              const menuToggleSticky = document.querySelector('#shopify-section-header-sticky .header__menu-icon');
              if(menuToggleSticky) {
                menuToggleSticky.click();
              }
            }) 
            /* Clicking on the header search close button */
            document.addEventListener('click', function(event) {
              const drawerCloseSearch = document.querySelectorAll('.snize-close-button-arrow');
              drawerCloseSearch.forEach(item => {
                if (event.target == item) {
                  event.preventDefault();
                  document.querySelector('#shopify-section-header').style.visibility = 'visible';
                  document.querySelector('#shopify-section-header-sticky').style.visibility = 'hidden';
                  document.querySelector('.header-sticky').style.display = 'block';
                }
              })
            }, false);
            
            let searchbutton = document.querySelectorAll('.header .header__right .header_search');
            let searchcontainer = document.querySelector('.quick-search');
            searchbutton && searchbutton.forEach(btn => {
                btn.addEventListener('click', event => {
                  event.preventDefault();
                  searchcontainer.classList.add('active');
                  searchcontainer.classList.add('visible');
                  document.body.classList.add('search-open');     
                  document.querySelector('.header-sticky').style.display = 'none';            
                })
            })
            let searchclose = document.querySelector('.quick-search_close');
                searchclose.addEventListener('click', event => {
                searchcontainer.classList.remove('active');
                searchcontainer.classList.remove('visible');
                document.body.classList.remove('search-open');
                document.querySelector('.header-sticky').style.display = 'block';
                })
          }, 200);
          keeplookingfornav;
        })
     }
   

  theme.headerNavMenu = new headerNavMenu;

}

theme.headerNavMenu();